import ReactHalfCard from './RatingHalfCard';

export default ReactHalfCard;
